import { render, staticRenderFns } from "./FotterBar.vue?vue&type=template&id=90a8add6"
import script from "./FotterBar.vue?vue&type=script&lang=js"
export * from "./FotterBar.vue?vue&type=script&lang=js"
import style0 from "./FotterBar.vue?vue&type=style&index=0&id=90a8add6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports